



























import Vue from 'vue';
import Component from 'vue-class-component';
import {mdiTrashCan} from '@mdi/js';
import {Prop} from 'vue-property-decorator';
import {Size} from '@/enums';

@Component
export default class ButtonDeleteAction extends Vue {
  @Prop({default: false}) private disabled!: boolean;
  @Prop({default: false}) private loading!: boolean;
  @Prop({default: Size.Small}) private size!: Size;
  private iconDelete = mdiTrashCan;
  private sizeExtraSmall = Size.ExtraSmall;
  private sizeSmall = Size.Small;
  private sizeMedium = Size.Medium;
  private sizeLarge = Size.Large;
  private sizeExtraLarge = Size.ExtraLarge;
}
